import { render, staticRenderFns } from "./PlacementTestsLists.vue?vue&type=template&id=43ec44c5&"
import script from "./PlacementTestsLists.vue?vue&type=script&lang=js&"
export * from "./PlacementTestsLists.vue?vue&type=script&lang=js&"
import style0 from "./PlacementTestsLists.vue?vue&type=style&index=0&id=43ec44c5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports